/* IVUSE+ Build Your Stack: compound prefill

   Reads ?compounds=handle1,handle2,handle3 from the URL and selects those
   compound tiles on the Build Your Stack page. The builder then sizes the tier
   by itself: 1 compound = Single Protocol, 2 = Dual Protocol, 3 = Full Stack.

   Example:
   /pages/build-your-stack?compounds=pt-141,selank

   Self-contained. Does not touch the builder's code or its cart payload.
   Waits for the builder to start (it fills the Your Stack slots when ready),
   then clicks each matching tile once. Handles that are not on the page are
   skipped. At most 3 compounds are read.
*/
(function () {
  'use strict';

  var MAX_COMPOUNDS = 3;
  var POLL_MS = 50;
  var TIMEOUT_MS = 6000;

  var raw = new URLSearchParams(window.location.search).get('compounds');
  if (!raw) return;

  var seen = {};
  var handles = raw
    .split(',')
    .map(function (s) { return s.trim().toLowerCase(); })
    .filter(function (s) {
      if (!s || seen[s] || !/^[a-z0-9-]+$/.test(s)) return false;
      seen[s] = true;
      return true;
    })
    .slice(0, MAX_COMPOUNDS);

  if (!handles.length) return;

  function builderReady() {
    return !!(
      document.getElementById('build-your-stack') &&
      document.querySelector('#bys-widget-slots .bys__widget-slot')
    );
  }

  function applySelection() {
    handles.forEach(function (handle) {
      var cell = document.querySelector('.bys__cell[data-product-handle="' + handle + '"]');
      if (cell && cell.getAttribute('aria-checked') !== 'true') cell.click();
    });
  }

  var waited = 0;
  (function poll() {
    if (builderReady()) {
      applySelection();
      return;
    }
    waited += POLL_MS;
    if (waited >= TIMEOUT_MS) return;
    setTimeout(poll, POLL_MS);
  })();
})();
